/* Phoenix Global — nav utilities.
   Loaded by every custom section. Two enhancements:
   (1) AJAX add-to-cart with a live cart-badge bump (no full page nav).
   (2) Predictive search in the drawer (Shopify /search/suggest.json).
   Both opt-in by markup convention — if the page doesn't have the relevant
   classes, the script just no-ops.                                       */
(function () {
  'use strict';

  // -------- (0) mobile hamburger drawer (shared chrome) -----------------
  // Single global handler. Operates on `[data-nav-toggle]` (the hamburger
  // button) + `[data-nav-drawer]` (the drawer overlay) — emitted by the
  // pg-chrome snippet. Replaces the per-section IIFEs that lived inline in
  // each section's <script> block.
  (function () {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;
    var closeBtn = drawer.querySelector('[data-nav-close]');
    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    Array.prototype.forEach.call(drawer.querySelectorAll('a'), function (a) {
      a.addEventListener('click', closeDrawer);
    });
  })();

  // -------- helpers -----------------------------------------------------
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // -------- (1) live cart badge ----------------------------------------
  function renderBadge(itemCount) {
    Array.prototype.forEach.call(document.querySelectorAll('.nav__cart'), function (link) {
      var existing = link.querySelector('[data-cart-count]');
      if (itemCount > 0) {
        if (existing) {
          existing.textContent = itemCount;
        } else {
          var span = document.createElement('span');
          span.className = 'nav__cart-badge';
          span.setAttribute('data-cart-count', '');
          span.textContent = itemCount;
          link.appendChild(span);
        }
        // brief amber pulse so a successful add is felt
        link.classList.add('nav__cart--bumped');
        setTimeout(function () { link.classList.remove('nav__cart--bumped'); }, 700);
      } else if (existing) {
        existing.remove();
      }
    });
  }

  function ajaxAdd(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add ' + r.status);
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderBadge(cart.item_count); return cart; });
  }

  // -------- (1b) add-to-cart confirmation modal ------------------------
  // After a successful AJAX add, ask the shopper to go straight to checkout
  // or keep shopping. Injected once, reused thereafter.
  var cartModal = null;
  function money(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }
  function withWidth(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function buildCartModal() {
    if (cartModal) return cartModal;
    var overlay = document.createElement('div');
    overlay.className = 'pg-cartmodal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Added to cart');
    overlay.innerHTML =
      '<div class="pg-cartmodal__card">' +
        '<button class="pg-cartmodal__close" type="button" aria-label="Close">&times;</button>' +
        '<div class="pg-cartmodal__head">' +
          '<span class="pg-cartmodal__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>' +
          '<span class="pg-cartmodal__added">Added to cart</span>' +
        '</div>' +
        '<div class="pg-cartmodal__item" data-cm-item></div>' +
        '<div class="pg-cartmodal__meta" data-cm-meta></div>' +
        '<div class="pg-cartmodal__actions">' +
          '<button class="pg-cartmodal__btn pg-cartmodal__btn--ghost" type="button" data-cm-keep>Keep shopping</button>' +
          '<a class="pg-cartmodal__btn pg-cartmodal__btn--primary" href="/checkout" data-cm-checkout>Checkout</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    function close() {
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('pg-cartmodal-lock');
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.pg-cartmodal__close').addEventListener('click', close);
    overlay.querySelector('[data-cm-keep]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
    cartModal = overlay;
    return overlay;
  }

  function showCartModal(cart, variantId) {
    var overlay = buildCartModal();
    var vid = parseInt(variantId, 10);
    var item = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].id === vid || cart.items[i].variant_id === vid) { item = cart.items[i]; break; }
    }
    var itemEl = overlay.querySelector('[data-cm-item]');
    var metaEl = overlay.querySelector('[data-cm-meta]');
    if (item) {
      var img = item.image || (item.featured_image && item.featured_image.url) || '';
      var vtitle = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="pg-cartmodal__vtitle">' + escapeHtml(item.variant_title) + '</div>' : '';
      itemEl.innerHTML =
        (img ? '<img class="pg-cartmodal__thumb" src="' + withWidth(img, 160) + '" alt="' + escapeHtml(item.product_title) + '">' : '') +
        '<div class="pg-cartmodal__info">' +
          '<div class="pg-cartmodal__title">' + escapeHtml(item.product_title) + '</div>' +
          vtitle +
          '<div class="pg-cartmodal__qtyprice">Qty ' + item.quantity + ' &middot; ' + money(item.final_line_price) + '</div>' +
        '</div>';
    } else {
      itemEl.innerHTML = '';
    }
    metaEl.innerHTML = 'Cart subtotal (' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ') &middot; <b>' + money(cart.items_subtotal_price) + '</b>';
    overlay.classList.add('is-open');
    document.documentElement.classList.add('pg-cartmodal-lock');
    var primary = overlay.querySelector('[data-cm-checkout]');
    if (primary) { try { primary.focus(); } catch (err) {} }
  }

  // Intercept any link that goes to /cart/add (the PDP tray "Add to cart" CTA).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/cart/add"]');
    if (!link) return;
    // Volume-tier CTAs route to /pages/volume-pricing — those don't match here.
    var href = link.getAttribute('href') || '';
    var idMatch = /[?&]id=(\d+)/.exec(href);
    if (!idMatch) return;
    var qtyMatch = /[?&]quantity=(\d+)/.exec(href);
    var variantId = idMatch[1];
    var qty = qtyMatch ? parseInt(qtyMatch[1], 10) : 1;
    e.preventDefault();
    link.classList.add('is-loading');
    ajaxAdd(variantId, qty)
      .then(function (cart) { showCartModal(cart, variantId); })
      .catch(function (err) {
        // On any failure, fall back to the original page-nav behaviour.
        console.warn('[pg-nav-utils] AJAX cart add failed, falling back', err);
        window.location.href = href;
      })
      .finally(function () { link.classList.remove('is-loading'); });
  });

  // On initial page load, make sure the badge matches /cart.js (handles the
  // case where the user added a different tab and the Liquid-rendered count
  // is stale).
  if (document.querySelector('.nav__cart')) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderBadge(cart.item_count); })
      .catch(function () { /* silent — keep server-rendered badge */ });
  }

  // -------- (2) predictive search --------------------------------------
  Array.prototype.forEach.call(document.querySelectorAll('.nav__drawer-search'), function (form) {
    var input = form.querySelector('input[type="search"]');
    if (!input) return;

    var results = document.createElement('div');
    results.className = 'nav__drawer-search-results';
    results.setAttribute('role', 'listbox');
    form.parentNode.insertBefore(results, form.nextSibling);

    var debounce;
    function suggest(q) {
      if (!q || q.length < 2) {
        results.innerHTML = '';
        results.classList.remove('is-open');
        return;
      }
      var url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product'
        + '&resources[limit]=5'
        + '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length === 0) {
            results.innerHTML = '<div class="nav__drawer-search-empty">No matches for &ldquo;' + escapeHtml(q) + '&rdquo;</div>';
          } else {
            results.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
              return (
                '<a class="nav__drawer-search-result" href="' + p.url + '">'
                +   (img
                      ? '<img src="' + img + '" alt="" loading="lazy">'
                      : '<span class="nav__drawer-search-noimg" aria-hidden="true"></span>')
                +   '<span class="nav__drawer-search-info">'
                +     '<span class="nav__drawer-search-title">' + escapeHtml(p.title) + '</span>'
                +     (p.price ? '<span class="nav__drawer-search-price">' + p.price + '</span>' : '')
                +   '</span>'
                + '</a>'
              );
            }).join('');
          }
          results.classList.add('is-open');
        })
        .catch(function () { /* silent */ });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { suggest(input.value.trim()); }, 250);
    });
    input.addEventListener('blur', function () {
      // small delay so a tap on a result fires before we hide
      setTimeout(function () { results.classList.remove('is-open'); }, 200);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.children.length) results.classList.add('is-open');
    });
  });
})();
